import { TenantSettingsSchema } from '@terra/shared-schemas-orchestrator';
import { UpdateIpAllowlistSchema } from '@terra/shared-utils';
import { z } from 'zod';
import { TenantRemediationCodingToolsSettingsSchema } from './remediation-coding-tools.schema';

export {
  RemediationCodingToolConfigSchema,
  RemediationCodingToolIdSchema,
  TenantRemediationCodingToolsSettingsSchema,
  UpdateTenantRemediationCodingToolsSettingsSchema,
} from './remediation-coding-tools.schema';

export {
  PDF_REPORT_IMAGE_MIME_TYPES,
  PDF_REPORT_COVER_TEXT_COLORS,
  DEFAULT_PDF_REPORT_COVER_TEXT_COLOR,
  PdfReportBrandingResponseSchema,
  PdfReportBrandingSchema,
  PdfReportBrandingSettingsSchema,
  PdfReportCoverTextColorSchema,
  resolvePdfReportPageFooterText,
  UpdatePdfReportBrandingSchema,
  UpdatePdfReportBrandingSettingsSchema,
} from './pdf-report-branding.schema';
export type {
  PdfReportImageMimeType,
  PdfReportCoverTextColor,
} from './pdf-report-branding.schema';

export const TenantSettingsResponseSchema = z.object({
  tenantSettings: TenantSettingsSchema.nullable(),
  remediationCodingTools: TenantRemediationCodingToolsSettingsSchema,
});

export const OffensiveOperationsKillSwitchStatusSchema = z.object({
  enabled: z.boolean(),
  enabledAt: z.iso.datetime().nullable(),
  enabledBy: z.string().nullable(),
  reason: z.string().nullable(),
});

export const EnableOffensiveOperationsKillSwitchSchema = z.object({
  reason: z.string().nullable(),
});

export const TenantIpAllowlistEntryStateSchema = z.object({
  cidr: z.string().min(1),
  description: z.string().optional(),
});

export const TenantIpAllowlistStateSchema = z.object({
  enabled: z.boolean(),
  entries: z.array(TenantIpAllowlistEntryStateSchema),
  updatedAt: z.string().nullable(),
  updatedBy: z.string().nullable(),
});

export const UpdateTenantIpAllowlistSchema = UpdateIpAllowlistSchema;

export const TenantIpAllowlistWithCurrentIpSchema =
  TenantIpAllowlistStateSchema.extend({
    currentIp: z.string().nullable(),
  });
